module.exports = __webpack_public_path__ + "img/img_2.68d8c7e9.png";